<template>
  <div class="body">
    <van-nav-bar title="修改收货地址" left-text left-arrow @click-left="onClickLeft" class="topNav"/>
    <div class="content animated fadeInRight fast">
      <van-address-edit
        :address-info="info"
        :area-list="areaList"
        show-search-result
        @save="onSave"
      />
    </div>
  </div>
</template>

<script>
import { AddressEdit } from "vant";
import Vue from "vue";
Vue.use(AddressEdit);
import area from "../../utils/area.js";
import { AddressDetail } from "../../apis/https.js";
import { getSessionStorage } from "../../utils/storage.js";
export default {
  data() {
    return {
      areaList: {},
      id: "",
      info: {
        name: "",
        tel: "",
        province: "",
        city: "",
        county: "",
        addressDetail: "",
        areaCode:"",
      },
      token: ""
    };
  },
  created() {
    this.areaList = area;
  },
  activated() {
    this.id = this.$route.query.id;
    this.token = getSessionStorage("login_token");
    this.AddressDetail(this.id, this.token);
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    onSave(addressInfo) {
      let name = addressInfo.name;
      let phone = addressInfo.tel;
      let detail = addressInfo.addressDetail;
      let region = `${addressInfo.province},${addressInfo.city},${
        addressInfo.county
      }`;
      // this.AddAddress(name,phone,detail,region,token)
    },
    AddressDetail(id, token) {
      this.$toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true, // 禁用背景点击
        loadingType: "spinner",
        message: "加载中"
      });
      AddressDetail(id, token).then(res => {
          this.$toast.clear();
          let data = res.data.detail;
          //赋值
          this.info.name = data.name;
          this.info.tel = data.phone;
          this.info.province = data.region.province;
          this.info.city = data.region.city;
          this.info.county = data.region.region;
          this.info.addressDetail = data.detail;
          // this.info.areaCode= '220102'
      });
    },
    AddAddress(name, phone, detail, region, token) {
      AddAddress(name, phone, detail, region, token).then(res => {
        if (res.code == 1) {
          this.$router.go(-1);
        } else {
          this.$toast.fail("添加失败");
        }
      }).catch(e=>{});
    }
  }
};
</script>
<style lang="less" scoped>
@import url("../../style/skin.less");
.body {
  background: #f4f8fb;
  min-height: 100vh;
  overflow: hidden;
  .topNav {
    position: fixed;
    width: 100%;
    top: 0;
    i {
      color: #323233 !important;
    }
  }
  .content {
    margin-top: 46px;
    margin-bottom: 46px;
  }
}
</style>